"use client";

import { MotionConfig } from "motion/react";
import type { ReactNode } from "react";

export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <MotionConfig reducedMotion="user" transition={{ type: "tween", duration: 0.25, ease: "easeOut" }}>
      {children}
    </MotionConfig>
  );
}
